// Preserve entered digits; PBX history can contain translated or transferred destinations.
export function recentDialRows(attempts){
 const byNumber=new Map();
 for(const row of attempts){
  const number=String(row.number||'');
  if(!/^[+*#0-9]{1,24}$/.test(number)||!Number.isFinite(Number(row.dialed)))continue;
  if(!byNumber.has(number)||byNumber.get(number).dialed<Number(row.dialed))byNumber.set(number,{number,dialed:Number(row.dialed)});
 }
 return [...byNumber.values()].sort((a,b)=>b.dialed-a.dialed).slice(0,50);
}
